import authentication from "@irati/auth"
import {Poll, PollResultsVisibility} from "@irati/types"

const MANAGER_ASSIGNMENT = "Manager"
const canSeePollResults = (poll: Poll) => {
  if (!poll.active || !poll.resultVisibility || poll.resultVisibility === PollResultsVisibility.ResultVisibilityEveryone) {
    return true
  }
  const teamAssignments = authentication.teamAssignments()
  const isManager = teamAssignments && teamAssignments.some(({assignment}) => assignment === MANAGER_ASSIGNMENT)
  const isAdmin = authentication.isGlobalAdmin()
  return (
    (poll.resultVisibility === PollResultsVisibility.ResultVisibilityAdminsOnly && isAdmin) ||
    (poll.resultVisibility === PollResultsVisibility.ResultVisibilityAdminsAndManagers && (isAdmin || isManager))
  )
}
export default canSeePollResults
